import { useTranslation } from 'react-i18next';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Tooltip } from '@mui/material';

type Props = {
  params: any;
  onMarkAsNotSoftware: (row: unknown) => void;
  onForceCrawl: (row: unknown) => void;
};

const ActionButtonsFalseNegatives = ({ params, onMarkAsNotSoftware, onForceCrawl }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Tooltip title={t('crawlerInboxPage.forceFullCrawlActioButton')}>
        <IconButton size="small" onClick={() => onForceCrawl(params.row)}>
          <CheckIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t('validation.finishStep.notSW')}>
        <IconButton size="small" onClick={() => onMarkAsNotSoftware(params?.row)}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ActionButtonsFalseNegatives;
